/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { listAwards } from '../fn/awards/list-awards';
import { ListAwards$Params } from '../fn/awards/list-awards';
import { ProfileAwardsWithProfiles } from '../models/profile-awards-with-profiles';

@Injectable({ providedIn: 'root' })
export class AwardsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listAwards()` */
  static readonly ListAwardsPath = '/rest/awards/{max}';

  /**
   * Get list of awards.
   *
   * List awards with best profiles (count of profiles for each award is controlled by parameter 'max').
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAwards()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAwards$Response(params: ListAwards$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileAwardsWithProfiles>>> {
    return listAwards(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of awards.
   *
   * List awards with best profiles (count of profiles for each award is controlled by parameter 'max').
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAwards$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAwards(params: ListAwards$Params, context?: HttpContext): Observable<Array<ProfileAwardsWithProfiles>> {
    return this.listAwards$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileAwardsWithProfiles>>): Array<ProfileAwardsWithProfiles> => r.body)
    );
  }

}
